import { Component, OnInit, HostListener } from '@angular/core';
import { momDashboard } from '../models/MOMForm';
import { UserService } from '../services/user.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { MasterMOMService } from '../services/master-mom.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import Notiflix from "notiflix";
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css'],
  providers: [ToastrUtilsService]
})

export class ReportComponent implements OnInit {
  searchText: string;
  login_UserID: any;
  checkBoxVal: number = 1;
  isTBT = false;
  disableMore: boolean;
  PostStartIndex: number = 1;
  PostMaxCount: number = 10;
  model: any = {};
  ifcountgreaterthanzero: boolean;
  value: any;
    data: any;
    actionType: string;
    noDataImage: string;
    isLoader: boolean=false;
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private modalService: BsModalService,
    private userService: UserService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute, ) { }


  @HostListener("window:scroll", [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!this.disableMore) {
        this.disableMore = true;

        this.getMoreSearch();
      }

    }
  }
  ngOnInit(): void {
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.login_UserID = user.id;
    var Role = Number(user.role);
    if (Role != 1) {
      this._router.navigate(['/dashboard'])
    }
    }
    
   
    this.isTBT = user.isTBT == 'false' ? false : true;
    this.getSearchList(true);
    this.model.startDate = null;
    this.model.endDate = null;
    this.ifcountgreaterthanzero = false;
    this.PostMaxCount = 10;
  }

  search() {
    this.getSearchList(true);
  }
  getMoreSearch() {
    this.getSearchList(false);
  }
  getSearchList(isStart: boolean) {
    ;
   // Notiflix.Block.Dots('div#pageloadcontainer');
    this.isLoader = true;
    let inpValue = new momDashboard();

    inpValue.userUno = this.login_UserID;
    inpValue.actionType = this.checkBoxVal == 2 ? 'ATTENDANCE' : this.checkBoxVal == 3 ? 'TBD' : 'MEETING';
    if (this.checkBoxVal == 4)
      inpValue.actionType = 'Active'
    inpValue.searchText = this.searchText;
    inpValue.startdt = (this.model.startDate != null && this.model.startDate != undefined) ? this.model.startDate : null;
    inpValue.enddt = (this.model.endDate != null && this.model.endDate != undefined) ? this.model.endDate : null;
    this.PostStartIndex = (this.PostStartIndex == undefined || this.PostStartIndex < 1 || isStart) ? 1 : this.PostStartIndex;
    inpValue.startIndex = this.PostStartIndex;
    inpValue.maxCount = this.PostMaxCount;
    this.momMasterservice.getDivMeetingList(inpValue)
      .subscribe((data: any) => {
        this.isLoader = false;
        if (this.PostStartIndex == 1) {
          this.data = [];
        }
        let dataList: any = [];
        dataList = data;
        if (this.actionType == 'Active Users') {
          for (var i = 0; i < dataList.length; i++) {
            let inputData = new momDashboard();
            inputData.userName = dataList[i].userName;
            inputData.divisionName = dataList[i].divisionName;
            inputData.firstName = dataList[i].firstName;
            inputData.lastName = dataList[i].lastName;
            inputData.emailId = dataList[i].emailId;
            inputData.prNumber = dataList[i].prNumber;
            inputData.picture = dataList[i].picture;
            this.data.push(inputData);
          }


          this.disableMore = (dataList.length >= 10) ? false : true;
          if (dataList.length > 0) {
            this.ifcountgreaterthanzero = true;
            this.PostStartIndex = this.PostStartIndex + 1;
          }
        }
        else {
          this.data = data;
        }
        //Notiflix.Block.Remove('div#pageloadcontainer', 500);
      },
        (error) => {
          this.isLoader = false;
        //  Notiflix.Block.Remove('div#pageloadcontainer', 500);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.isLoader = false;
       // Notiflix.Block.Remove('div#pageloadcontainer', 500);
      });

  }
  TypeCheckBoxSelection(val) {
    this.checkBoxVal = val;
    this.searchText = '';
    this.actionType = this.checkBoxVal == 2 ? 'Attendance' : this.checkBoxVal == 3 ? 'TBT' : 'Meeting';
    if (this.checkBoxVal == 4)
      this.actionType = 'Active Users';
    this.getSearchList(true);
  }
}
